import {
  deleteMainTask,
  DeleteTask,
  deleteTask,
  getBizAreaList,
  getMainTaskList,
  getTaskDetail,
  GetTaskList,
  getTaskList,
  retestTask,
  stopTask,
  getTaskDetailUseCaseStatus,
  getTaskDetailUseCaseCount,
  getTaskExecList,
} from '@/api/data-protection/task-list'
import { Message } from '@/components/message'
import { useRequest } from 'ahooks'
import { t } from '@/i18n'
import { TaskListResult } from '../plan-list/utils'

export interface BizAreaItem {
  id: string
  name: string
}

// 获取任务列表
export const UseGetTaskList = (props: GetTaskList) => {
  const {
    runAsync: run,
    data,
    loading,
  } = useRequest(() => getTaskList(props), {
    refreshDeps: [props],
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || t('获取任务列表失败'))
    },
  })

  return [run, data?.data as TaskListResult, loading] as const
}

// 删除子任务
export const useDeleteTaskExec = () => {
  const { runAsync: run, loading } = useRequest((data: DeleteTask) => deleteTask(data), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || t('删除任务列表失败'))
    },
  })

  return [run, loading] as const
}

// TODO:获取安全域列表
export const useGetBizAreaList = () => {
  const { data, runAsync: run } = useRequest(() => getBizAreaList(), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || t('获取安全域列表失败'))
    },
  })

  return [(data?.data?.items as BizAreaItem[]) || [], run] as const
}

// 停止任务
export const useStopTask = () => {
  const { runAsync: run } = useRequest(data => stopTask(data), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || t('任务停止失败'))
    },
  })
  return [run] as const
}

// 任务复测
export const useReTestTask = () => {
  const { runAsync: run, loading } = useRequest(data => retestTask(data), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || t('任务复测失败'))
    },
  })

  return [run, loading] as const
}

// 删除主任务
export const useDeleteTask = () => {
  const { runAsync: run, loading } = useRequest(data => deleteMainTask(data), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || t('删除主任务失败'))
    },
  })
  return [run, loading] as const
}

// 获取任务列表
export const useGetTaskList = () => {
  const { runAsync: run, loading } = useRequest(params => getMainTaskList(params), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || t('获取任务列表失败'))
    },
  })

  return [run, loading] as const
}

// 获取任务执行列表
export const useGetTaskExecList = () => {
  const { runAsync: run, loading } = useRequest(params => getTaskExecList(params), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || t('获取任务执行列表失败'))
    },
  })

  return [run, loading] as const
}

// 获取任务详情
export const useGetTaskDetail = () => {
  const { runAsync: run, loading } = useRequest(params => getTaskDetail(params), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || t('获取任务详情失败'))
    },
  })

  return [run, loading] as const
}

// 获取任务详情用例状态列表
export const useGetTaskDetailUseCaseStatus = () => {
  const { runAsync: run, data } = useRequest(params => getTaskDetailUseCaseStatus(params), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || t('获取例状态列表失败'))
    },
  })
  return [run, data?.data?.list || []] as const
}

// 任务结果 根据用例状态统计用例数
export const useGetTaskDetailUseCaseCount = () => {
  const { runAsync: run, data } = useRequest(params => getTaskDetailUseCaseCount(params), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || t('获取例状态列表失败'))
    },
  })
  return [run, data?.data?.count || []] as const
}
